import React from 'react'
import { createRegisterableComponent, Features } from '@news-mono/web-common'
import {
    NightlyPreviousSpecialEditionsProps,
    NightlyPreviousSpecialEditions,
} from './PreviousSpecialEditions'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'

export const NightlyPreviousSpecialEditionsRegistration =
    createRegisterableComponent(
        'nightly-previous-special-editions',
        (props: NightlyPreviousSpecialEditionsProps, { store }) => {
            const { title, editions } = props
            const { toggles } = store.getState()
            const enabledEditions = editions.filter((edition) => {
                return isFeatureEnabled<Features>(
                    toFeatureState(toggles),
                    edition.featureToggle,
                    false,
                )
            })
            return (
                <NightlyPreviousSpecialEditions
                    title={title}
                    editions={enabledEditions}
                />
            )
        },
    )
